import { baseThemeData } from "./baseTheme";

const baseDefaultThemeData = {
  ...baseThemeData
};

const computePanelThemeData = () => {
  return {
    panel: {
      header: {
        icon: { defaultColor: baseDefaultThemeData.colors.iconColor },
        title: {
          defaultColor: baseDefaultThemeData.textColor
        },
        description: {
          defaultColor: baseDefaultThemeData.colors.brandColor
        }
      }
    }
  };
};

const computeExpandablePanelThemeData = () => {
  return {
    expandablePanel: {
      before: {
        borderTopColor: "#2c2c2c",
        boxShadow: "0px -1px 0px 0px",
        boxShadowColor: "#171717"
      },
      header: {
        icon: { defaultColor: baseDefaultThemeData.colors.iconColor },
        title: {
          defaultColor: baseDefaultThemeData.textColor,
          expandedColor: baseDefaultThemeData.colors.brandColor
        },
        arrow: {
          defaultColor: baseDefaultThemeData.textColor,
          expandedColor: baseDefaultThemeData.colors.brandColor
        }
      }
    }
  };
};

const computeListThemeData = () => {
  return {
    list: {
      item: {
        borderBottomColor: "rgb(23, 23, 23)",
        boxShadow: "0px 1px 0px 0px",
        boxShadowColor: "#2c2c2c",
        text: { defaultColor: "#cccccc" },
        checkbox: {
          checkedBackground: baseDefaultThemeData.colors.brandColor,
          unCheckedBackground: "#000000",
          defaultColor: "#000000"
        }
      }
    }
  };
};

const computeCheckboxListThemeData = () => {
  return {
    checkboxList: {
      title: {
        defaultColor: "#cccccc",
        borderBottomColor: "rgb(23, 23, 23)",
        boxShadow: "0px 1px 0px 0px",
        boxShadowColor: "#2c2c2c"
      }
    }
  };
};

const computeDrawerThemeData = () => {
  return {
    drawer: {
      header: {
        backgroundColor: "#0a0a0a"
      },
      area: { background: baseDefaultThemeData.backgrounds.mainBG },
      box: { background: baseDefaultThemeData.backgrounds.boxBG }
    }
  };
};

const getHeaderButtonPcStyles = () => {
  return {
    ...baseThemeData,
    colors: {
      ...baseThemeData.colors,
      textColorBtnOutlined: "#fc6200",
      outlinedBorderColor: "#fc6200"
    },
    typography: {
      ...baseThemeData.typography,
      fontSize: `1.4rem`,
      fontWeight: 900
    },
    backgrounds: {
      ...baseThemeData.backgrounds,
      hoverColorOutlined: baseDefaultThemeData.colors.brandColor
    },
    borders: {
      ...baseThemeData.borders,
      borderColor: baseThemeData.colors.brandColor,
      borderColorMobile: baseThemeData.colors.brandColor
    }
  };
};

const computeLinkButtonThemeData = () => {
  return {
    linkButtonTitle: {
      defaultColor: "#cccccc",
      borderBottomColor: "rgb(23, 23, 23)",
      boxShadow: "0px 1px 0px 0px",
      boxShadowColor: "#2c2c2c"
    },
    linkButton: {
      icon: { defaultColor: baseDefaultThemeData.colors.iconColor },
      title: { defaultColor: baseDefaultThemeData.colors.textColor },
      description: {
        defaultColor: baseDefaultThemeData.colors.brandColor
      },
      arrow: {
        defaultColor: "#ffffff"
      }
    }
  };
};

const computeLinkItemThemeData = () => {
  return {
    linkItem: {
      icon: { defaultColor: baseDefaultThemeData.colors.iconColor }
    }
  };
};

const computePopupThemeData = () => {
  return {
    popupButton: {
      fontFamily: "defaultBold",
      dotsFloatingBackgroundColor: "#0A0A0A",
      outlined: {
        background: "#fc6200",
        backgroundColor: "#000000",
        color: "#ffffff",
        borderColor: "#6c6c6c",
        hover: {
          backgroundColor: "#000000",
          color: "#ffffff",
          borderColor: "#ffffff"
        }
      },
      contained: {
        background: "#fc6200",
        color: "#000000",
        borderColor: "#fc6200",
        hover: {
          background: "#000000",
          color: "#fc6200",
          borderColor: "#fc6200"
        }
      },
      underlined: {
        color: "#fc6200",
        hover: {
          background: "none",
          color: "#fc6200"
        }
      }
    },
    popupContainer: {
      textColor: "#fc6200",
      subtitleColor: "#fc6200",
      message: {
        color: "#fc6200"
      },
      zIndex: 200,
      backgroundColor: "#111111",
      titleBackgroundColor: "#232323",
      iconColor: "#fc6200",
      pokerDownloadGuide: {
        titleWrapperColor: "#fc6200",
        underlineTextWrapperColor: "#fc6200",
        svgWrapperColor: "#fc6200"
      }
    },
    popupFooter: {
      fontFamily: "defaultMedium",
      color: "#a5a5a5"
    }
  };
};

const computeControlCenterThemeData = () => {
  return {
    controlCenter: {
      headerButton: {
        backgroundColor: "#121212",
        borderColor: "#4c4c4c",
        svgBackgroundColor: "#6c6c6c"
      }
    }
  };
};

const computeLanguagesDrawerThemeData = () => {
  return {
    languagesDrawer: {
      fontFamily: "defaultDemibold",
      checkedOptionBackgroundColor: "fc6200",
      backgroundColor: "#171717",
      textColor: "#FFFFFF"
    }
  };
};

export const DefaultThemeData = {
  getHeaderButtonPcStyles,
  ...baseDefaultThemeData,
  ...computePanelThemeData(),
  ...computeExpandablePanelThemeData(),
  ...computeDrawerThemeData(),
  ...computeListThemeData(),
  ...computeCheckboxListThemeData(),
  ...computeLinkButtonThemeData(),
  ...computeLinkItemThemeData(),
  ...computePopupThemeData(),
  ...computeControlCenterThemeData(),
  ...computeLanguagesDrawerThemeData()
};
